
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Filter, Plus } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuCheckboxItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import ExportButton from '@/components/common/ExportButton';

interface FilterControlsProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedStatuses: string[];
  onStatusChange: (status: string, checked: boolean) => void;
  onGroupToggle: () => void;
  groupByFamily: boolean;
  onAddInvoice: () => void;
  onExportCSV: () => boolean | Promise<boolean>;
  filteredInvoices: any[];
}

export const FilterControls: React.FC<FilterControlsProps> = ({
  searchTerm,
  onSearchChange,
  selectedStatuses,
  onStatusChange,
  onGroupToggle,
  groupByFamily,
  onAddInvoice,
  onExportCSV,
  filteredInvoices,
}) => {
  return (
    <div className="flex flex-col sm:flex-row justify-between gap-4">
      <div className="flex items-center space-x-2 w-full sm:w-auto">
        <div className="relative w-full sm:w-64">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input 
            placeholder="Search invoices..."
            className="pl-8"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="outline" size="sm" className="flex gap-1">
              <Filter className="h-4 w-4" />
              Filter
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="w-56">
            {['draft', 'unpaid', 'partial', 'paid', 'overdue'].map(status => (
              <DropdownMenuCheckboxItem
                key={status}
                checked={selectedStatuses.includes(status)}
                onCheckedChange={(checked) => onStatusChange(status, checked)}
              >
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </DropdownMenuCheckboxItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
        
        <Button 
          variant="outline"
          size="sm"
          onClick={onGroupToggle}
        >
          {groupByFamily ? 'Ungroup' : 'Group by Family'}
        </Button>
      </div>
      
      <div className="flex gap-2">
        <ExportButton 
          onExportCSV={onExportCSV}
          label="Export"
          disabled={filteredInvoices.length === 0}
        />
        <Button onClick={onAddInvoice}>
          <Plus className="mr-2 h-4 w-4" />
          New Invoice
        </Button>
      </div>
    </div>
  );
};
